export default __webpack_public_path__ + "static/nick-860cc7eb3fce3aa09018886f114d63b9.png";